import { MutableRefObject, useEffect, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { getFeatureFlag } from '../API/FeatureAPI'
import { ReactState } from '../Types/Types'
import { $debug } from '../Utils/ConsoleUtils'

export const useAppLicenceFeature = (featureFlag: string): Nullable<boolean> => {
    const [isFeatureFlag, setIsFeatureFlag]: ReactState<Nullable<boolean>> = useState<Nullable<boolean>>(null)

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    useEffect((): void => {
        getFeatureFlag(featureFlag, true)
            .then((isFeatureFlagLocal: Nullable<boolean>): void => {
                if (isMounted.current) {
                    setIsFeatureFlag(isFeatureFlagLocal ?? false)
                }
            })
            // We don't care about whether this errors.
            // But it is useful for debugging to output the error.
            .catch((e: Error): void => {
                $debug(e)

                if (isMounted.current) {
                    setIsFeatureFlag(false)
                }
            })
    }, [])

    return isFeatureFlag
}
